import Vue from 'vue';
import apiClient from '../../apiClient';

const state = {
  clients: [],
  clientInfo: {}
};

const actions = {
  clientsGet: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/clients`)
        .then(response => {
          commit('clientsList', response.data.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  clientInfo: ({ commit }, clientId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/clients/${clientId}`)
        .then(response => {
          commit('clientInfo', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  clientUpdate: (_context, { clientId, payload }) =>
    new Promise((resolve, reject) => {
      apiClient
        .patch(`/clients/${clientId}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  clientDelete: (_context, clientId) =>
    new Promise((resolve, reject) => {
      apiClient
        .delete(`/clients/${clientId}`)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  clientsList: (state, clients) => {
    Vue.set(state, 'clients', clients);
  },
  clientInfo: (state, clientInfo) => {
    Vue.set(state, 'clientInfo', clientInfo);
  }
};

export default {
  state,
  actions,
  mutations
};
